import { useLocation } from "react-router";
import type {
  IEnvironment,
  IHeroImage,
  IMenuItem,
  INavigationItemsMenu,
  SPLink,
} from "../InterfacesTypes/interfaces";
import { useEffect } from "react";

export const localBaseUrl = "/_proxy/tjansterprodukter/startsida2025";
// export const localBaseUrlCurrentNews = "/_proxy/tjansterprodukter/nyhetsarkiv";
//LOCALHOST - Kommentera bort denna när du ska ladda upp på https://logp.fmv.se/CommonCodeFiles/Forms/AllItems.aspx?RootFolder=%2FCommonCodeFiles%2FStartsida&FolderCTID=0x012000BA387ADA4A95704CA62CEA4BC672B0BB&View=%7B0F697FEE%2D0624%2D48E5%2D9BE9%2D0598EB3C7507%7D
//export const prodBaseUrl = "/tjansterprodukter"; 
//PRODUKTION - Använd när du ska ladda upp på LogP och Logistikportalen https://logp.fmv.se/CommonCodeFiles/Forms/AllItems.aspx?RootFolder=%2FCommonCodeFiles%2FStartsida&FolderCTID=0x012000BA387ADA4A95704CA62CEA4BC672B0BB&View=%7B0F697FEE%2D0624%2D48E5%2D9BE9%2D0598EB3C7507%7D
export const prodBaseUrl = "";

export const devBaseUrl = "/tjansterprodukter/dev";

export const getEnvironment = (): IEnvironment => {
  const environment: IEnvironment = {
    baseUrl: localBaseUrl,
    listapi: `${localBaseUrl}/_api/web/lists`, //_proxy/tjansterprodukter/_api/web/startsida2025/lists
    webapi: `${localBaseUrl}/_api/web`,
    imageUrl: "https://acteadev.sharepoint.com",
    currentNewsUrl: "/_proxy/tjansterprodukter/nyhetsarkiv/_api/web/lists",
  };

  if (window.location.pathname.search(devBaseUrl) !== -1) {
    environment.baseUrl = devBaseUrl;
    environment.listapi = `${devBaseUrl}/_api/web/lists`;
    environment.webapi = `${devBaseUrl}/_api/web`;
    environment.imageUrl = "https://logp.fmv.se";
    environment.currentNewsUrl =
      "/tjansterprodukter/nyhetsarkiv/_api/web/lists";
    // environment.imageUrl = "";
  } else if (window.location.pathname.search(prodBaseUrl) !== -1) {
    environment.baseUrl = prodBaseUrl;
    environment.listapi = `${prodBaseUrl}/_api/web/lists`;
    environment.webapi = `${prodBaseUrl}/_api/web`;
    //environment.imageUrl = "https://logp.fmv.se";
    //environment.imageUrl = "https://logistikportalen.fmv.se";
    environment.imageUrl = "";
    environment.currentNewsUrl =
      "/tjansterprodukter/nyhetsarkiv/_api/web/lists";
  }

  return environment;
};

export function getImageBySection(
  items: IHeroImage[],
  section: string
): IHeroImage | undefined {
  return items.find((item) => item.Section === section);
}

const toUrl = (l?: SPLink): string => (l?.Url ? l.Url : "#");

const toTitle = (t: unknown): string =>
  typeof t === "string" && t.trim().length > 0 ? t.trim() : "Untitled";

export function buildMenuTree(spItems: INavigationItemsMenu[]): IMenuItem[] {
  const nodes = new Map<number, IMenuItem>();
  const roots: IMenuItem[] = [];

  for (const it of spItems) {
    const node: IMenuItem = {
      ID: it.ID,
      Id: it.ID,
      Title: toTitle(it.Title),
      Href: toUrl(it.Link),
      ParentId: it.ParentId ?? undefined,
      subMenus: [],
      LinkRaw: it.Link,
      ItemOrder: it.ItemOrder,
    };
    nodes.set(it.ID, node);
  }

  for (const node of nodes.values()) {
    const pid = node.ParentId;
    if (pid && nodes.has(pid) && pid !== node.Id) {
      nodes.get(pid)!.subMenus!.push(node);
    } else {
      roots.push(node);
    }
  }

  const keepOrder = (arr: IMenuItem[]) => {
    arr.sort((a, b) => (a.ItemOrder ?? 0) - (b.ItemOrder ?? 0));

    for (const n of arr) {
      if (n.subMenus.length) keepOrder(n.subMenus);
    }
  };
  keepOrder(roots);
  return roots;
}

export const truncateText = (text: string, maxCharacters: number) => {
  if (text?.length <= maxCharacters) {
    return text;
  } else {
    return text?.substring(0, maxCharacters) + "\u2026";
  }
};

export const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const el =
      document.querySelector(".SPPageChromeAppDiv") ||
      document.querySelector("#s4-workspace") ||
      document.scrollingElement;

    el?.scrollTo({ top: 0 });
  }, [location.key]);

  return null;
};